import { render } from "./ListagemOSFilters.vue?vue&type=template&id=47996f0e"
import script from "./ListagemOSFilters.vue?vue&type=script&lang=js"
export * from "./ListagemOSFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__